import React from 'react';
import MarketAccessLinkColumn from './MarketAccessLinksColumn.jsx';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './MarketAccessLinksBlock.scss';

const MarketAccessLinksBlock = ({ className, linkColumns }) => {
  if (!linkColumns || linkColumns.length === 0) return null;

  return (
    <div className={cn('market-access-links-block', className)}>
      <div className="market-access-links-block__container">
        <div className="market-access-links-block__columns">
          {linkColumns.map((column, index) => (
            <MarketAccessLinkColumn {...column} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

MarketAccessLinksBlock.propTypes = {
  className: PropTypes.string,
  linkColumns: PropTypes.arrayOf(
    PropTypes.exact(MarketAccessLinkColumn.propTypes)
  ),
};

export default MarketAccessLinksBlock;
